<template>
  <b-container>
      <b-card>
        <FormIncident ref="FormIncident"
          :id="id"
          :request-form="requestForm"></FormIncident>
        <b-row class="m-0 mt-2">
          <b-col
            lg="12">
            <b-form @submit.prevent="saveHandling">
              <b-row class="m-0">
                <b-col md="6">
                  <validation-provider
                      #default="validationContext"
                      :name="$t('status')"
                      rules="required"
                      class="flex-grow"
                      slim>
                    <b-form-group
                      :label="$t('status')"
                      label-for="status">
                      <b-form-select
                        id="status"
                        class="required-select"
                        :options="listStatus"
                        text-field="label"
                        value-field="key"
                        v-model="modelStatus">
                        <!-- This slot appears above the options from 'options' prop -->
                        <template #first>
                          <b-form-select-option :value="null" disabled>-- Selecione uma opção --</b-form-select-option>
                        </template>
                      </b-form-select>
                        <b-form-invalid-feedback :class="[{'absolute': inline}]">
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                    </validation-provider>
                </b-col>
              </b-row>
              <b-row class="m-0">
                <b-col>
                  <!-- publicAccess -->
                  <b-form-group
                    :label="$t('preview')"
                    label-for="publicAccess">
                    <b-form-radio-group
                      id="publicAccess"
                      name="publicAccess"
                      v-model="publicAccess">
                      <b-form-radio :value="false">{{$t('private')}}</b-form-radio>
                      <b-form-radio :value="true">{{$t('public')}}</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                  <b-form-group
                    :label="$t('form_handling')"
                    label-for="treatment">
                    <simple-editor v-model="textTreatment" class="mb-2"/>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="m-0 pt-2">
                <b-col>
                  <b-form-group
                    :label="$t('forwarding_description_public')"
                    label-for="forwarding_description">
                    <simple-editor v-model="forwardingDescription" class="mb-2"/>
                    </b-form-group>
                </b-col>
              </b-row>
              <div class="mt-1 mb-2">
                <div class="flex justify-end">
                   <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mt-1 mr-1 float-right"
                    :disabled="!validateForm"
                    @click="saveHandling()">
                      {{$t('save')}}
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-secondary"
                    class="mt-1 mr-1 float-right"
                    @click="$router.push('/incident-form')">
                      {{$t('back')}}
                  </b-button>
                </div>
              </div>
            </b-form>
          </b-col>
        </b-row>
    </b-card>
  </b-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Datepicker from 'educatena-vuejs-datepicker'
import vSelect from 'vue-select'
import {
  BContainer,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BFormRadio,
  BFormRadioGroup,
  BFormTextarea,
  BFormSelect,
  BFormSelectOption,
  BCard,
  BTable,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
  BFormInvalidFeedback,
} from 'bootstrap-vue'

//Services
import IncidentFormHandlingService from '@/services/api/incident/RequestFormIncidentHandlingService'
import GenericService from '@/services/api/GenericService'

import SimpleEditor from '@/components/SimpleEditor.vue'

import FormIncident from './FormIncident'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    Datepicker,
    vSelect,
    BContainer,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BFormRadio,
    BFormRadioGroup,
    BFormTextarea,
    BFormSelect,
    BFormSelectOption,
    BCard,
    BTable,
    BCardText,
    BCardTitle,
    BCardFooter,
    BImg,
    BForm,
    BButton,
    BAlert,
    VBTooltip,
    ValidationObserver,
    ValidationProvider,
    BFormInvalidFeedback,
    SimpleEditor,
    //
    FormIncident,
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    id: null,
    requestForm : null,
    textTreatment: '',
    forwardingDescription: '',
    status: '',
    modelStatus: null,
    publicAccess: false,
    updateHistorys: false,
    listStatus: [],
    services: {
      incidentFormHandlingService: null,
      genericService: null,
    },
  }),
  methods: {
    saveHandling(){
      this.confirmTreatmentPublic(this.modelStatus)
    },
    confirmTreatmentPublic(status){
      if(this.publicAccess){
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Confirmação',
          acceptText: 'Sim',
          cancelText: 'Não',
          text: this.$t('protocol_query.msg_status_public_confirm'),
          accept: () => {
            this.save(status)
          }
        })
      }else{
        this.save(status)
      }
    },
    save(varStatus) {
      this.clearErrors(this.$validator)
      this.$vs.loading()

      this.services.incidentFormHandlingService.updateHandling(this.id, {
          id: this.id,
          description: this.textTreatment,
          forwarding_description: this.forwardingDescription,
          status: varStatus,
          public_access: this.publicAccess,
        })
        .then(
          data => {
            this.$vs.loading.close()
            this.clearFields()
            this.sucessNotify()
            //Update status view
            this.requestForm.request_form_incident_handling = data.request_form_incident_handling;
            //Consult again
            this.getData(this.id)
          },
          error => {
            this.showErrors(this.$validator, error)
          }
        )
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    getData(id) {
      this.$vs.loading()
      this.services.incidentFormHandlingService.read(id).then(
        data => {
          this.requestForm = data;
          this.status = this.requestForm.status;
          this.$vs.loading.close()
        },
        error => {
          this.$vs.loading.close()
        }
      ).finally(() => {
        this.$vs.loading.close()
      })
    },
    clearFields() {
      this.textTreatment = ''
      this.forwardingDescription = ''
      this.modelStatus = null
      this.publicAccess = false
    },
    confirmClosed() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja encerrar o atendimento?',
        accept: () => {
          this.saveClose()
        }
      })
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    sucessNotify() {
      this.$vs.notify({
        title: 'Successo!',
        text: 'Operação realizada com sucesso.',
        color: 'success',
        iconPack: 'feather',
        position: 'top-center',
        icon: 'icon-check-circle'
      })
      this.scrollToTop()
    },
  },
  computed: {
    validateForm() {
      return this.modelStatus !== null
    }
  },
  mounted() {
    //this.$vs.loading.close()
    if (this.id) {
      this.getData(this.id)
    }
  },
  beforeMount() {
    //this.$vs.loading()
    const promisses = []

    this.services.incidentFormHandlingService = IncidentFormHandlingService.build(this.$vs)
    this.services.genericService = GenericService.build(this.$vs)

    promisses.push(
      this.services.genericService.getFormHandlingStatus(this.id).then(
        data => {
          this.listStatus = data
        },
        error => {
          this.$vs.loading.close()
        }
      )
    )
  }
}
</script>
